import { MessageCircle } from "lucide-react";
import { CONTACT } from "../lib/data";

export default function WhatsAppFloat() {
  return (
    <a
      data-testid="whatsapp-float"
      href={`https://wa.me/${CONTACT.phoneIntl}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 right-6 z-40 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      <span className="relative flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.45)] btn-lift">
        <MessageCircle className="h-7 w-7" />
      </span>
      <span className="absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-navy text-white text-xs font-medium px-3 py-2 rounded-md opacity-0 group-hover:opacity-100 transition pointer-events-none">
        Chat on WhatsApp
      </span>
    </a>
  );
}
